export default "__VITE_ASSET__223b0166__"